module.exports = __webpack_public_path__ + "img/beer_fill - Kopie.png";